import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Προκλήσεις',
    lead: 'Οργανώστε ομαδικές προκλήσεις: βήματα, ύπνο, προπονήσεις και άλλα, με προαιρετική κατάταξη.',
    noCompany: 'Επιλέξτε μια εταιρεία για να δείτε τις προκλήσεις της.',
    forbidden: 'Δεν έχετε πρόσβαση στις προκλήσεις αυτής της εταιρείας.',
    empty: 'Δεν υπάρχουν ακόμα προκλήσεις — δημιουργήστε την πρώτη.',
  },
  counts: {
    active: 'Ενεργές προκλήσεις',
    draft: 'Πρόχειρα',
    completed: 'Ολοκληρωμένες',
    totalParticipants: 'Σύνολο συμμετεχόντων',
  },
  sections: {
    activePublished: 'Ενεργές & δημοσιευμένες',
    draftsCompleted: 'Πρόχειρα & ολοκληρωμένες',
  },
  card: {
    type: 'Τύπος',
    mode: 'Μορφή',
    period: 'Περίοδος',
    goal: 'Στόχος',
    reward: 'Ανταμοιβή',
    participants: 'Συμμετέχοντες',
    engagement: 'Δέσμευση',
    completion: 'Ολοκλήρωση',
    leaderboardVisible: 'Ορατή κατάταξη',
    leaderboardHidden: 'Κρυφή κατάταξη',
  },
  mode: {
    individual: 'Ατομική',
    group: 'Ομαδική',
  },
  status: {
    draft: 'Πρόχειρο',
    active: 'Ενεργή',
    paused: 'Σε παύση',
    completed: 'Ολοκληρώθηκε',
  },
  type: {
    steps: 'Βήματα',
    sleep: 'Ύπνος',
    workouts: 'Προπονήσεις',
    meditation: 'Διαλογισμός',
    custom: 'Προσαρμοσμένο',
  },
  actions: {
    newChallenge: 'Νέα πρόκληση',
    publish: 'Δημοσίευση',
    pause: 'Παύση',
    resume: 'Συνέχιση',
    finish: 'Ολοκλήρωση',
    duplicate: 'Αντιγραφή ως πρόχειρο',
    duplicateSuffix: 'αντίγραφο',
    viewLeaderboard: 'Προβολή κατάταξης',
    hideLeaderboard: 'Απόκρυψη κατάταξης',
  },
  leaderboard: {
    title: 'Κατάταξη',
    empty: 'Δεν υπάρχουν ακόμα συμμετέχοντες.',
  },
  form: {
    title: 'Νέα πρόκληση',
    submit: 'Δημιουργία πρόκλησης',
    cancel: 'Ακύρωση',
    fields: {
      title: 'Τίτλος',
      description: 'Περιγραφή',
      type: 'Τύπος',
      mode: 'Μορφή',
      startDate: 'Ημερομηνία έναρξης',
      endDate: 'Ημερομηνία λήξης',
      goalValue: 'Τιμή στόχου',
      unit: 'Μονάδα',
      reward: 'Ανταμοιβή',
      leaderboardVisible: 'Εμφάνιση κατάταξης στους συμμετέχοντες',
    },
    errors: {
      required: 'Αυτό το πεδίο είναι υποχρεωτικό.',
      endBeforeStart: 'Η ημερομηνία λήξης δεν μπορεί να είναι πριν την ημερομηνία έναρξης.',
    },
  },
};
